import { AfterViewInit, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'kts-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit, AfterViewInit {
  backgroundImages = ['home', 'automation', 'enginering', 'programming', 'about-us', 'contact-us'];
  backGroundObj = {
    'background-image': 'url("./assets/back-grounds/' + this.backgroundImages[0] + '.jpg")'
  };
  sub: Subscription;
  constructor(private router: Router) {

    this.sub = router.events.subscribe((val) => {
      // see also
      if (val instanceof NavigationEnd) {
        console.log(val);
        let ind;
        switch (val.url) {
          case '/services/automation':
            ind = 1;
            break;
          case '/services/engineering':
            ind = 2;
            break;
          case '/services/programming':
            ind = 3;
            break;
          case '/about-us':
            ind = 4;
            break;
          case '/contact-us':
            ind = 5;
            break;
          default:
            ind = 0;
            break;
        }
        this.backGroundObj = {
          'background-image': 'url("./assets/back-grounds/' + this.backgroundImages[ind] + '.jpg")'
        };
      }
    });
  }

  ngOnInit() {
  }
  ngAfterViewInit() {
    $('.body-container').scroll(() => {
      if ($('.body-container').scrollTop() > 60) {
        $('nav').addClass('shrunk');
      } else {
        $('nav').removeClass('shrunk');
      }
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/Yi-Yu/Documents/Actual Documents/Katiso/katiso/src/app/components/main/main.component.ts